import { PackageDeliveryType } from "../PackageDeliveryType";

class   CustomCategoryWeightRange {
    public id: string;
    public customCategoryId: string;
    public agencyId: string;
    public from: number;
    public to: number;
    public price: number;
    public deliveryType: PackageDeliveryType;

    constructor(
        id: string,
        customCategoryId: string,
        agencyId: string,
        from: number,
        to: number, 
        price: number,
        deliveryType: PackageDeliveryType,
    ) {
        this.id = id;
        this.customCategoryId = customCategoryId;
        this.agencyId = agencyId;
        this.from = from;
        this.to = to;
        this.price = price;
        this.deliveryType = deliveryType;
    }
}
export default CustomCategoryWeightRange